import { useQuery } from '@apollo/client';

import { toast } from '@shared/ui';
import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import { useAccountCompanyId } from 'application/hooks';

import {
  AuthCurrentUserDocument,
  AuthCurrentUserQuery,
  useAuthUserGetSberReauthUriQuery,
} from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { BILLING_PAGE_PATH_ALIAS } from '@entities/billing';

import { TEXTS } from './texts';

const REDIRECT_URL = `${window.location.hostname}${BILLING_PAGE_PATH_ALIAS}`;

interface UseSberIDReauth {
  sberIdButtonDisabled: boolean;
  handleReauth: () => void;
}

const useSberIDReauth = (): UseSberIDReauth => {
  const { openModal } = useModalContext();

  const { data: userData } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const sberIdButtonDisabled = Boolean(userData?.currentUserPureQuery?.mainCompany?.sberIdButtonState?.isDisabled);
  const companyId = useAccountCompanyId();

  const { data } = useAuthUserGetSberReauthUriQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { companyId, redirectUri: REDIRECT_URL },
  });

  const doRedirect = (link: string) => {
    window.location.href = link;
    toast.info(TEXTS.SBER_ID_REAUTH_START_TEXT);
  };

  const handleReauth = () => {
    const link = data?.userGetSberLinkUri;

    if (link) {
      openModal(ModalTypes.SBER_REDIRECT_WARNING, { onConfirm: () => doRedirect(link) });
    } else {
      toast.error(TEXTS.SBER_ID_REAUTH_ERROR_TEXT);
    }
  };

  return { sberIdButtonDisabled, handleReauth };
};

export default useSberIDReauth;
